import { validateInputs, isEmptyString } from './form.js'

/**
 * Clear any POST resubmission warnings on page load
 */
$(document).ready(function() {
    // Replace history state on page load to clear any POST cache
    if (window.history && window.history.replaceState && window.performance && window.performance.navigation) {
        // Check if page was loaded via back/forward button
        if (window.performance.navigation.type === 2) {
            // Page was loaded via back button, replace state to clear POST cache
            const cleanUrl = window.location.pathname + window.location.search
            window.history.replaceState({ formSubmitted: false }, '', cleanUrl)
        }
    }
})

/**
 * Newsletter form submission handler
 */
$(document).on('submit', '.newsletter-form', function (e) {
    // Prevent all default form behavior
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    const $form = $(this)
    
    // Prevent double submission
    const $submitButton = $form.find('button[type="submit"]')
    if ($submitButton.prop('disabled')) {
        return false
    }

    const isValid = validateNewsletterForm($form)

    if (!isValid) {
        return false
    }

    // Show loading state
    const originalButtonText = $submitButton.find('span').text()
    $submitButton.prop('disabled', true)
    $submitButton.find('span').text('Submitting...')

    // Hide previous general error message (field-specific errors will be re-validated)
    $form.find('.newsletter-form__error-message').fadeOut(200)
    $form.closest('.newsletter-form-wrapper').find('.newsletter-form__success-message').fadeOut(200)

    const formData = new FormData($form[0])
    formData.append('action', 'newsletter_form')

    $.ajax({
        type: 'POST',
        url: localized.admin_ajax,
        data: formData,
        dataType: 'json',
        contentType: false,
        processData: false,
        cache: false,
        success: function (response) {
            if (response.success && response.data && response.data.form_sent) {
                if (window.history && window.history.replaceState) {
                    const cleanUrl = window.location.pathname + window.location.search
                    window.history.replaceState({ formSubmitted: true }, '', cleanUrl)
                }
                $form[0].reset()
                showNewsletterSuccess($form, originalButtonText)
            } else {
                const errorMessage = response.data?.error_message || 'An error occurred. Please try again.'
                showNewsletterError($form, errorMessage)
                resetSubmitButton($submitButton, originalButtonText)
            }
        },
        error: function (response) {
            const errorMessage = response.responseJSON?.data?.error_message || 'An error occurred. Please try again.'
            showNewsletterError($form, errorMessage)
            resetSubmitButton($submitButton, originalButtonText)
        }
    })

    return false
})

/**
 * Validate newsletter form
 */
const validateNewsletterForm = ($form) => {
    let valid = true

    // Don't clear errors upfront - let individual validation functions handle clearing/updating errors
    // This ensures errors persist until each field is re-validated

    // Validate name
    const $nameInput = $form.find('#newsletter-name')
    if (!validateNewsletterInput($nameInput, 'Name is required')) {
        valid = false
    }

    // Validate email
    const $emailInput = $form.find('#newsletter-email')
    if (!validateNewsletterEmail($emailInput)) {
        valid = false
    }

    // Validate privacy checkbox
    const $privacyCheckbox = $form.find('#newsletter-privacy')
    const checkboxId = $privacyCheckbox.attr('id')
    const checkboxErrorId = `${checkboxId}-error`
    const $submitWrapper = $form.find('.newsletter-form__submit')
    const $checkboxWrapper = $privacyCheckbox.closest('.newsletter-form__checkbox-wrapper')
    const $label = $checkboxWrapper.find('label[for="' + checkboxId + '"]')
    
    // Remove existing error message if any
    $form.find(`#${checkboxErrorId}`).remove()
    
    if (!$privacyCheckbox.is(':checked')) {
        $checkboxWrapper.addClass('error')
        
        // Add error message above submit button in a full line
        $submitWrapper.before(`<div id="${checkboxErrorId}" class="newsletter-form__checkbox-error" role="alert" aria-live="polite">You must agree to the privacy policy</div>`)
        
        // Add ARIA attributes for accessibility
        $privacyCheckbox.attr('aria-invalid', 'true')
        $privacyCheckbox.attr('aria-describedby', checkboxErrorId)
        $label.attr('aria-describedby', checkboxErrorId)
        
        valid = false
    } else {
        // Remove error state if valid
        $checkboxWrapper.removeClass('error')
        $privacyCheckbox.removeAttr('aria-invalid aria-describedby')
        $label.removeAttr('aria-describedby')
        // Remove error message (already removed above, but keep for safety)
        $form.find(`#${checkboxErrorId}`).remove()
    }

    return valid
}

/**
 * Validate newsletter input field
 */
const validateNewsletterInput = ($input, errorMessage) => {
    const value = $input.val()
    const inputId = $input.attr('id')
    const errorId = `${inputId}-error`
    const $field = $input.closest('.newsletter-form__field')
    const $label = $field.find('label[for="' + inputId + '"]')
    
    // Remove existing error message if any
    $field.find(`#${errorId}`).remove()

    if (isEmptyString(value)) {
        $field.addClass('error')
        
        // Add error message below input
        $input.after(`<span id="${errorId}" class="newsletter-form__field-error" role="alert" aria-live="polite">${errorMessage}</span>`)
        
        // Add ARIA attributes for accessibility
        $input.attr('aria-invalid', 'true')
        $input.attr('aria-describedby', errorId)
        $label.attr('aria-describedby', errorId)
        
        return false
    }

    // Remove error state if valid
    $field.removeClass('error')
    $input.removeAttr('aria-invalid aria-describedby')
    $label.removeAttr('aria-describedby')
    $field.find(`#${errorId}`).remove()

    return true
}

/**
 * Validate newsletter email field
 */
const validateNewsletterEmail = ($emailInput) => {
    const email = $emailInput.val()
    const inputId = $emailInput.attr('id')
    const errorId = `${inputId}-error`
    const $field = $emailInput.closest('.newsletter-form__field')
    const $label = $field.find('label[for="' + inputId + '"]')
    
    // Remove existing error message if any
    $field.find(`#${errorId}`).remove()

    if (isEmptyString(email)) {
        $field.addClass('error')
        
        // Add error message below input
        $emailInput.after(`<span id="${errorId}" class="newsletter-form__field-error" role="alert" aria-live="polite">Email is required</span>`)
        
        // Add ARIA attributes for accessibility
        $emailInput.attr('aria-invalid', 'true')
        $emailInput.attr('aria-describedby', errorId)
        $label.attr('aria-describedby', errorId)
        
        return false
    }

    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(email)) {
        $field.addClass('error')
        
        // Add error message below input
        $emailInput.after(`<span id="${errorId}" class="newsletter-form__field-error" role="alert" aria-live="polite">Please enter a valid email address</span>`)
        
        // Add ARIA attributes for accessibility
        $emailInput.attr('aria-invalid', 'true')
        $emailInput.attr('aria-describedby', errorId)
        $label.attr('aria-describedby', errorId)
        
        return false
    }

    // Remove error state if valid
    $field.removeClass('error')
    $emailInput.removeAttr('aria-invalid aria-describedby')
    $label.removeAttr('aria-describedby')
    $field.find(`#${errorId}`).remove()

    return true
}

/**
 * Show newsletter error message
 */
const showNewsletterError = ($form, message) => {
    const $errorMessage = $form.find('.newsletter-form__error-message')
    $errorMessage
        .attr('role', 'alert')
        .attr('aria-live', 'assertive')
        .text(message)
        .fadeIn(350)
}

/**
 * Reset newsletter form completely
 */
const resetNewsletterForm = ($form, originalButtonText) => {
    const $submitButton = $form.find('button[type="submit"]')
    
    // Reset button state
    $submitButton.prop('disabled', false)
    $submitButton.find('span').text(originalButtonText)
    
    // Reset form fields
    $form[0].reset()
    
    // Clear all error states
    $form.find('.newsletter-form__field').removeClass('error')
    $form.find('.newsletter-form__checkbox-wrapper').removeClass('error')
    $form.find('.newsletter-form__field-error').remove()
    $form.find('.newsletter-form__checkbox-error').remove()
    $form.find('.newsletter-form__error-message').hide()
    
    // Reset ARIA attributes
    $form.find('input, textarea, checkbox').removeAttr('aria-invalid aria-describedby')
    $form.find('label').removeAttr('aria-describedby')
    
    // Show form if hidden
    $form.show()
}

/**
 * Show newsletter success screen
 */
const showNewsletterSuccess = ($form, originalButtonText) => {
    const $section = $form.closest('.newsletter-layout')
    const $successScreen = $section.find('.newsletter-form__success-message')
    
    // Add ARIA attributes for accessibility
    $successScreen.attr('role', 'status')
    $successScreen.attr('aria-live', 'polite')
    
    // Overlay success message on top of content (don't hide existing content)
    $successScreen.css('display', 'flex').hide().fadeIn(300)
    
    // Auto-hide success message after 5 seconds and reset form
    setTimeout(function() {
        $successScreen.fadeOut(300, function() {
            // Reset form completely after success message hides
            setTimeout(function() {
                resetNewsletterForm($form, originalButtonText)
            }, 100)
        })
    }, 5000)
}

/**
 * Reset submit button to original state
 */
const resetSubmitButton = ($button, originalText) => {
    $button.prop('disabled', false)
    $button.find('span').text(originalText)
}
